var _defs, _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _tspan10, _tspan11, _tspan12, _tspan13, _tspan14, _tspan15, _tspan16, _tspan17, _tspan18, _tspan19, _tspan20, _tspan21, _tspan22, _tspan23, _tspan24, _tspan25, _tspan26, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCombScheme4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 188.83 114.3",
    id: "svg348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs32"
  }, /*#__PURE__*/React.createElement("marker", {
    id: "ArrowWide",
    overflow: "visible",
    markerHeight: 1,
    markerWidth: 1,
    orient: "auto-start-reverse",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1 1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 .125 0)",
    d: "m3-3-3 3 3 3",
    fill: "none",
    stroke: "context-stroke",
    id: "path2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient19"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fde725",
    offset: 0,
    id: "stop5"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ad151",
    offset: 0.2,
    id: "stop7"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22a884",
    offset: 0.4,
    id: "stop9"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2a788e",
    offset: 0.6,
    id: "stop11"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414487",
    offset: 0.8,
    id: "stop13"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#440154",
    offset: 1,
    id: "stop15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient20",
    x1: 19.754,
    x2: 88.344,
    y1: 111.88,
    y2: 111.88,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient53",
    x1: 66.994,
    x2: 71.523,
    y1: 66.733,
    y2: 66.733,
    gradientTransform: "matrix(1.0367 0 0 1.0367 4.0831 -5.5217)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linearGradient19"
  }), /*#__PURE__*/React.createElement("marker", {
    id: "ArrowWide-4",
    overflow: "visible",
    markerHeight: 1,
    markerWidth: 1,
    orient: "auto-start-reverse",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1 1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 .125 0)",
    d: "m3-3-3 3 3 3",
    fill: "none",
    stroke: "context-stroke",
    id: "path20"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "ArrowWide-2",
    overflow: "visible",
    markerHeight: 1,
    markerWidth: 1,
    orient: "auto-start-reverse",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1 1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 .125 0)",
    d: "m3-3-3 3 3 3",
    fill: "none",
    stroke: "context-stroke",
    id: "path23"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "ArrowWide-9",
    overflow: "visible",
    markerHeight: 1,
    markerWidth: 1,
    orient: "auto-start-reverse",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1 1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 .125 0)",
    d: "m3-3-3 3 3 3",
    fill: "none",
    stroke: "context-stroke",
    id: "path26"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "ArrowWide-0",
    overflow: "visible",
    markerHeight: 1,
    markerWidth: 1,
    orient: "auto-start-reverse",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1 1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180,0.125,0)",
    d: "M 3,-3 0,0 3,3",
    fill: "none",
    stroke: "context-stroke",
    id: "path29"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.2174 -3.5428)",
    id: "g346"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 0.54861,
    id: "g40"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.959,
    cy: 35.277,
    r: 2.0735,
    fill: "#22a884",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle34"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.959,
    cy: 57.956,
    r: 3.1102,
    fill: "#7ad151",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle36"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.959,
    cy: 80.635,
    r: 1.0367,
    fill: "#fde725",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle38"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#22a884",
    stroke: "#000",
    strokeWidth: 0.54861,
    id: "g50"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47.724,
    cy: 30.029,
    r: 2.0735,
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle42"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.724,
    cy: 38.992,
    r: 2.0735,
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle44"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.724,
    cy: 21.065,
    r: 2.0735,
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle46"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.687,
    cy: 21.065,
    r: 2.0735,
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle48"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#7ad151",
    stroke: "#000",
    strokeWidth: 0.54861,
    id: "g64"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56.687,
    cy: 30.029,
    r: 3.1102,
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle52"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.724,
    cy: 56.919,
    r: 3.1102,
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle54"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.687,
    cy: 56.919,
    r: 3.1102,
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.724,
    cy: 47.956,
    r: 3.1102,
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle58"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.724,
    cy: 65.883,
    r: 3.1102,
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle60"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.687,
    cy: 83.81,
    r: 3.1102,
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle62"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fde725",
    stroke: "#000",
    strokeWidth: 0.54861,
    id: "g78"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56.687,
    cy: 38.992,
    r: 1.0367,
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle66"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.687,
    cy: 65.883,
    r: 1.0367,
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle68"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.724,
    cy: 74.846,
    r: 1.0367,
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle70"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.724,
    cy: 83.81,
    r: 1.0367,
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle72"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.687,
    cy: 92.773,
    r: 1.0367,
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle74"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.724,
    cy: 92.773,
    r: 1.0367,
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle76"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#22a884",
    stroke: "#000",
    strokeWidth: 0.54861,
    id: "g88"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56.687,
    cy: 47.956,
    r: 2.0735,
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle80"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.687,
    cy: 74.846,
    r: 2.0735,
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle82"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.084,
    cy: 22.534,
    r: 2.0735,
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle84"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.05,
    cy: 22.534,
    r: 2.0735,
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle86"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 118.16,
    cy: 74.112,
    r: 3.1102,
    fill: "#7ad151",
    stroke: "#000",
    strokeWidth: 0.54861,
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle90"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0367 0 0 1.0367 3.1657 7.637)",
    stroke: "#000",
    strokeWidth: 0.52917,
    id: "g94"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 119.07,
    cy: 64.119,
    r: 1,
    fill: "#fde725",
    stroke: "#000",
    strokeWidth: 0.52917,
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle92"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 0.54861,
    id: "g122"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 95.084,
    cy: 91.304,
    r: 1.0367,
    fill: "#fde725",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle96"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.05,
    cy: 91.304,
    r: 1.0367,
    fill: "#fde725",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle98"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.05,
    cy: 74.112,
    r: 3.1102,
    fill: "#7ad151",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle100"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.084,
    cy: 74.112,
    r: 1.0367,
    fill: "#fde725",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle102"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.084,
    cy: 39.726,
    r: 2.0735,
    fill: "#22a884",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle104"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.05,
    cy: 39.726,
    r: 3.1102,
    fill: "#7ad151",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle106"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.64,
    cy: 39.726,
    r: 3.1102,
    fill: "#7ad151",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle108"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.61,
    cy: 39.726,
    r: 2.0735,
    fill: "#22a884",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle110"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185.05,
    cy: 22.534,
    r: 1.0886,
    fill: "#440154",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle112"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185.05,
    cy: 39.726,
    r: 2.343,
    fill: "#414487",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle114"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185.05,
    cy: 56.919,
    r: 2.6126,
    fill: "#2a788e",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle116"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185.05,
    cy: 74.112,
    r: 0.8294,
    fill: "#22a884",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle118"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185.05,
    cy: 91.304,
    r: 0.27474,
    fill: "#7ad151",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle120"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0367 0 0 1.0367 20.297 -8.3406)",
    strokeWidth: 0.52917,
    id: "g130"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.018 110.26c0.70366-6e-3 66.902-1.0281 68.061-1.0002 1.1582 0.0279 1.1292 5.2552 0 5.2385-1.1292-0.0168-67.335-1.0121-68.061-1.0003-0.72532 0.0118-0.70366-3.2322 0-3.238z",
    fill: "url(#linearGradient20)",
    stroke: "#000",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path124"
  }), /*#__PURE__*/React.createElement("text", {
    x: 54.093437,
    y: 120.83282,
    fill: "#999999",
    fontFamily: "Arial",
    fontSize: "4.2333px",
    stroke: "#000000",
    "text-align": "center",
    textAnchor: "middle",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      paintOrder: "markers stroke fill"
    },
    xmlSpace: "preserve",
    id: "text128"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 54.093437,
    y: 120.83282,
    fill: "#000000",
    fontSize: "4.2333px",
    stroke: "none",
    strokeWidth: 0.52917,
    id: "tspan126"
  }, "Combined carbon chain length")))), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.54861,
    id: "g138"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.106 35.277 23.471-14.212",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.106 35.277 23.471-5.2485",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.106 35.277 23.471 3.715",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path136"
  })), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 0.54861,
    id: "g172"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    id: "g164"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m43.577 47.956-23.471-12.679",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.105 57.956 23.472-27.927",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.105 57.956 23.472-10",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.105 57.956 23.472-1.0367",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.105 57.956 23.472 7.9268",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.105 57.956 23.472 25.854",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.106 80.635 23.471-5.7885",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.106 80.635 23.471 3.175",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.106 80.635 23.471 12.139",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.106 80.635 23.471-14.752",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.106 80.635 23.471-41.643",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.106 35.277 23.471 39.569",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path162"
  })), /*#__PURE__*/React.createElement("text", {
    x: 75.906311,
    y: 51.804379,
    fill: "#000000",
    fontFamily: "Arial",
    fontSize: "4.3889px",
    "text-align": "center",
    textAnchor: "middle",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      paintOrder: "markers stroke fill"
    },
    xmlSpace: "preserve",
    id: "text170"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 75.906311,
    y: 51.804379,
    id: "tspan166"
  }, "group")), _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 75.906311,
    y: 57.290478,
    id: "tspan168"
  }, "on")))), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.54861,
    id: "g192"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m60.834 21.065 6.7575 35.855",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path174"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.834 30.029 6.7575 26.891",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.834 38.992 6.7575 17.927",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.834 47.956 6.7575 8.964",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.834 56.919 6.7575 4.65e-4",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.834 65.883 6.7575-8.963",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.834 74.846 6.7575-17.927",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.834 83.81 6.7575-26.89",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path188"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.834 92.773 6.7575-35.854",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path190"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 73.813,
    y: 61.589,
    width: 4.147,
    height: 4.147,
    rx: 0.51837,
    ry: 0.51837,
    fill: "url(#linearGradient53)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.54861,
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "rect194"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.54861,
    id: "g206"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m84.187 56.92 6.7499-34.386",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path196"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.187 56.92 6.7499-17.193",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.187 56.92 6.7499-7.76e-4",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.187 56.92 6.6463 17.192",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.187 56.92 6.7499 34.385",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path204"
  })), /*#__PURE__*/React.createElement("text", {
    x: 165.26309,
    y: 55.043873,
    fill: "#000000",
    fontFamily: "Arial",
    fontSize: "4.3889px",
    strokeLinecap: "round",
    strokeWidth: 0.54861,
    "text-align": "center",
    textAnchor: "middle",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      paintOrder: "markers stroke fill"
    },
    xmlSpace: "preserve",
    id: "text212"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 165.26309,
    y: 55.043873,
    id: "tspan208"
  }, "Compute")), _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 165.26309,
    y: 60.529972,
    id: "tspan210"
  }, "probability"))), /*#__PURE__*/React.createElement("g", {
    fill: "#b3b3b3",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeWidth: 0.54861,
    id: "g224"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m152.8 56.919h24.958",
    markerEnd: "url(#ArrowWide)",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.8 74.112h24.958",
    markerEnd: "url(#ArrowWide-4)",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path216"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.8 91.304h24.958",
    markerEnd: "url(#ArrowWide-2)",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.8 39.726h24.958",
    markerEnd: "url(#ArrowWide-9)",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path220"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.8 22.534h24.958",
    markerEnd: "url(#ArrowWide-0)",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "path222"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ccc",
    stroke: "#000",
    strokeWidth: 0.54861,
    id: "g232"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 164.72,
    cy: 107.65,
    r: 2.737,
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle226"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.84,
    cy: 107.65,
    r: 1.9387,
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle228"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.96,
    cy: 107.65,
    r: 1.3715,
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle230"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fontFamily: "Arial",
    strokeLinecap: "round",
    strokeWidth: 0.54861,
    textAnchor: "middle",
    id: "g286"
  }, /*#__PURE__*/React.createElement("text", {
    x: 151.6636,
    y: 116.9008,
    fontSize: "4.3889px",
    "text-align": "center",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      paintOrder: "markers stroke fill"
    },
    xmlSpace: "preserve",
    id: "text236"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 151.6636,
    y: 116.9008,
    fill: "#000000",
    fontSize: "4.3889px",
    strokeWidth: 0.54861,
    id: "tspan234"
  }, "Probability"))), /*#__PURE__*/React.createElement("g", {
    fontSize: "2.9259px",
    id: "g250"
  }, /*#__PURE__*/React.createElement("text", {
    x: 138.91338,
    y: 108.67326,
    "text-align": "center",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      paintOrder: "markers stroke fill"
    },
    xmlSpace: "preserve",
    id: "text240"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 138.91338,
    y: 108.67326,
    fontSize: "2.9259px",
    strokeWidth: 0.54861,
    id: "tspan238"
  }, "\u215B"))), /*#__PURE__*/React.createElement("text", {
    x: 151.78362,
    y: 108.67326,
    "text-align": "center",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      paintOrder: "markers stroke fill"
    },
    xmlSpace: "preserve",
    id: "text244"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 151.78362,
    y: 108.67326,
    fontSize: "2.9259px",
    strokeWidth: 0.54861,
    id: "tspan242"
  }, "\xBC"))), /*#__PURE__*/React.createElement("text", {
    x: 164.67386,
    y: 108.67326,
    "text-align": "center",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      paintOrder: "markers stroke fill"
    },
    xmlSpace: "preserve",
    id: "text248"
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 164.67386,
    y: 108.67326,
    fontSize: "2.9259px",
    strokeWidth: 0.54861,
    id: "tspan246"
  }, "\xBD")))), /*#__PURE__*/React.createElement("g", {
    fontSize: "2.9259px",
    id: "g284"
  }, /*#__PURE__*/React.createElement("text", {
    x: 99.565651,
    y: 23.292297,
    "text-align": "center",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      paintOrder: "markers stroke fill"
    },
    xmlSpace: "preserve",
    id: "text254"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 99.565651,
    y: 23.292297,
    strokeWidth: 0.54861,
    id: "tspan252"
  }, "\xD7"))), /*#__PURE__*/React.createElement("text", {
    x: 99.565643,
    y: 40.484962,
    "text-align": "center",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      paintOrder: "markers stroke fill"
    },
    xmlSpace: "preserve",
    id: "text258"
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 99.565643,
    y: 40.484962,
    strokeWidth: 0.54861,
    id: "tspan256"
  }, "\xD7"))), /*#__PURE__*/React.createElement("text", {
    x: 99.565651,
    y: 74.870308,
    "text-align": "center",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      paintOrder: "markers stroke fill"
    },
    xmlSpace: "preserve",
    id: "text262"
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 99.565651,
    y: 74.870308,
    strokeWidth: 0.54861,
    id: "tspan260"
  }, "\xD7"))), /*#__PURE__*/React.createElement("text", {
    x: 99.565651,
    y: 92.062965,
    "text-align": "center",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      paintOrder: "markers stroke fill"
    },
    xmlSpace: "preserve",
    id: "text266"
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 99.565651,
    y: 92.062965,
    strokeWidth: 0.54861,
    id: "tspan264"
  }, "\xD7"))), /*#__PURE__*/React.createElement("text", {
    x: 122.12563,
    y: 40.484962,
    "text-align": "center",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      paintOrder: "markers stroke fill"
    },
    xmlSpace: "preserve",
    id: "text270"
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 122.12563,
    y: 40.484962,
    strokeWidth: 0.54861,
    id: "tspan268"
  }, "\xD7"))), /*#__PURE__*/React.createElement("text", {
    x: 122.38481,
    y: 74.870308,
    "text-align": "center",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      paintOrder: "markers stroke fill"
    },
    xmlSpace: "preserve",
    id: "text274"
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 122.38481,
    y: 74.870308,
    strokeWidth: 0.54861,
    id: "tspan272"
  }, "\xD7"))), /*#__PURE__*/React.createElement("text", {
    x: 110.84564,
    y: 40.75713,
    "text-align": "center",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      paintOrder: "markers stroke fill"
    },
    xmlSpace: "preserve",
    id: "text278"
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 110.84564,
    y: 40.75713,
    strokeWidth: 0.54861,
    id: "tspan276"
  }, "+"))), /*#__PURE__*/React.createElement("text", {
    x: 111.10483,
    y: 75.142464,
    "text-align": "center",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      paintOrder: "markers stroke fill"
    },
    xmlSpace: "preserve",
    id: "text282"
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    x: 111.10483,
    y: 75.142464,
    strokeWidth: 0.54861,
    id: "tspan280"
  }, "+"))))), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 0.54861,
    id: "g300"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 104.05,
    cy: 56.919,
    r: 3.1102,
    fill: "#7ad151",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle288"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.084,
    cy: 56.919,
    r: 3.1102,
    fill: "#7ad151",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle290"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.64,
    cy: 56.919,
    r: 2.0735,
    fill: "#22a884",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle292"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.61,
    cy: 56.919,
    r: 1.0367,
    fill: "#fde725",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle294"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.65,
    cy: 56.919,
    r: 1.0367,
    fill: "#fde725",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle296"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.61,
    cy: 56.919,
    r: 2.0735,
    fill: "#22a884",
    style: {
      paintOrder: "markers stroke fill"
    },
    id: "circle298"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fontFamily: "Arial",
    strokeLinecap: "round",
    strokeWidth: 0.54861,
    textAnchor: "middle",
    id: "g342"
  }, /*#__PURE__*/React.createElement("g", {
    fontSize: "2.9259px",
    id: "g322"
  }, /*#__PURE__*/React.createElement("text", {
    x: 99.565643,
    y: 57.677631,
    "text-align": "center",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      paintOrder: "markers stroke fill"
    },
    xmlSpace: "preserve",
    id: "text304"
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    x: 99.565643,
    y: 57.677631,
    strokeWidth: 0.54861,
    id: "tspan302"
  }, "\xD7"))), /*#__PURE__*/React.createElement("text", {
    x: 122.12563,
    y: 57.677631,
    "text-align": "center",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      paintOrder: "markers stroke fill"
    },
    xmlSpace: "preserve",
    id: "text308"
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    x: 122.12563,
    y: 57.677631,
    strokeWidth: 0.54861,
    id: "tspan306"
  }, "\xD7"))), /*#__PURE__*/React.createElement("text", {
    x: 143.13037,
    y: 57.677631,
    "text-align": "center",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      paintOrder: "markers stroke fill"
    },
    xmlSpace: "preserve",
    id: "text312"
  }, _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    x: 143.13037,
    y: 57.677631,
    strokeWidth: 0.54861,
    id: "tspan310"
  }, "\xD7"))), /*#__PURE__*/React.createElement("text", {
    x: 110.84564,
    y: 57.949799,
    "text-align": "center",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      paintOrder: "markers stroke fill"
    },
    xmlSpace: "preserve",
    id: "text316"
  }, _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    x: 110.84564,
    y: 57.949799,
    strokeWidth: 0.54861,
    id: "tspan314"
  }, "+"))), /*#__PURE__*/React.createElement("text", {
    x: 132.62799,
    y: 57.949799,
    "text-align": "center",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      paintOrder: "markers stroke fill"
    },
    xmlSpace: "preserve",
    id: "text320"
  }, _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    x: 132.62799,
    y: 57.949799,
    strokeWidth: 0.54861,
    id: "tspan318"
  }, "+")))), /*#__PURE__*/React.createElement("g", {
    fontSize: "4.3889px",
    id: "g340",
    transform: "translate(0,7.6199812)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 16.005831,
    y: 6.7587743,
    "text-align": "center",
    style: {
      paintOrder: "markers stroke fill"
    },
    xmlSpace: "preserve",
    id: "text326"
  }, _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    x: 16.005831,
    y: 6.7587743,
    fontSize: "4.3889px",
    strokeWidth: 0.54861,
    id: "tspan324"
  }, "FA profile"))), /*#__PURE__*/React.createElement("text", {
    x: 52.165474,
    y: 6.7230568,
    "text-align": "center",
    style: {
      paintOrder: "markers stroke fill"
    },
    xmlSpace: "preserve",
    id: "text330"
  }, _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    x: 52.165474,
    y: 6.7230568,
    fontSize: "4.3889px",
    strokeWidth: 0.54861,
    id: "tspan328"
  }, "Molecular species"))), /*#__PURE__*/React.createElement("text", {
    x: 120.84108,
    y: 6.7587743,
    "text-align": "center",
    style: {
      paintOrder: "markers stroke fill"
    },
    xmlSpace: "preserve",
    id: "text334"
  }, _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    x: 120.84108,
    y: 6.7587743,
    fontSize: "4.3889px",
    strokeWidth: 0.54861,
    id: "tspan332"
  }, "Set of molecular species"))), /*#__PURE__*/React.createElement("text", {
    x: 185.02109,
    y: 6.7587743,
    "text-align": "center",
    style: {
      paintOrder: "markers stroke fill"
    },
    xmlSpace: "preserve",
    id: "text338"
  }, _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    x: 185.02109,
    y: 6.7587743,
    fontSize: "4.3889px",
    strokeWidth: 0.54861,
    id: "tspan336"
  }, "Lipid profile"))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.4825,
    y: 3.3102,
    width: 197.43,
    height: 114.8,
    rx: 0.11321,
    ry: 0.082801,
    display: "none",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.44386,
    id: "rect344"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombScheme4);
export default __webpack_public_path__ + "static/media/comb_scheme_4.316ae85689070f07b71427bc3ba29737.svg";
export { ForwardRef as ReactComponent };